<app-dialog [headerText]="title" saveText="Overwrite" [showTopCancelButton]="false" [saveButtonType]="'transparent'"
            [body]="body" (save)="dismiss(FileAction.OVERWRITE)" (cancel)="dismiss(FileAction.CANCEL)" [additionalFooterButtons]="appendBtn">
    <ng-template #body>
        <div class="container">
            <div>{{msg}}</div>
        </div>
    </ng-template>
    <ng-template #appendBtn>
        <fd-button-bar
                label="Append"
                fdType="transparent"
                [fdCompact]="true"
                (click)="dismiss(FileAction.APPEND)"
                id="dialog-append-btn"
                class="uppercase-btn"
                ariaLabel="OK Transparent">
        </fd-button-bar>
    </ng-template>
</app-dialog>
